import React from "react";
import { styled } from "@linaria/react";
import Card from "../../Card";
import { spacings } from "../../Theme";

const LegendWrapper = styled.div`
  display: flex;
  gap: ${spacings.m};
  justify-content: space-between;

  & > *:first-child {
    flex-basis: 25%;
    align-self: flex-end;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  & > *:last-child {
    flex: 1;
  }
`;

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  flex-wrap: wrap;
  row-gap: 16px;
  justify-content: space-between;
`;

export const LeftOptions = styled.div`
  :not(:empty) {
    display: flex;
    flex-wrap: wrap;
    column-gap: 8px;
    row-gap: 8px;
    margin-right: auto;
  }
  overflow-x: auto;
`;

export const RightOptions = styled.div`
  :not(:empty) {
    display: flex;
    column-gap: 8px;
    flex-wrap: wrap;
    row-gap: 8px;

    &:first-child {
      margin-left: auto;
    }
  }
`;

const Legend = styled.div`
  :not(:empty) {
    display: flex;
    column-gap: 16px;
    flex-wrap: wrap;
    row-gap: 8px;
    justify-content: flex-end;
    min-height: 18px;
  }
`;

const Chart = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;

  /* fine tuning to get some fat off the right border, -5px visually works when marginRight is undefined and when it is 10px */
  margin-right: -5px;
`;

interface P {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children: React.ReactNode;
  leftOptions?: React.ReactNode;
  rightOptions?: React.ReactNode;
  legend?: React.ReactNode;
  legendLeft?: React.ReactNode;
  className?: string;
}

const ChartCard = ({
  title,
  subtitle,
  children,
  leftOptions,
  rightOptions,
  legend,
  legendLeft,
  className,
}: P) => {
  const legendRight = legend ? <Legend>{legend}</Legend> : null;
  return (
    <Card title={title} subtitle={subtitle} className={className}>
      {leftOptions || rightOptions ? (
        <OptionsWrapper>
          {leftOptions && <LeftOptions>{leftOptions}</LeftOptions>}
          {rightOptions && <RightOptions>{rightOptions}</RightOptions>}
        </OptionsWrapper>
      ) : null}
      <Chart>{children}</Chart>
      {legendLeft ? (
        <LegendWrapper>
          {legendLeft}
          {legendRight}
        </LegendWrapper>
      ) : (
        legendRight
      )}
    </Card>
  );
};

export default React.memo(ChartCard);
